import { render, staticRenderFns } from "./ServiceNotes.vue?vue&type=template&id=bd45c8e6&scoped=true"
import script from "./ServiceNotes.vue?vue&type=script&lang=js"
export * from "./ServiceNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd45c8e6",
  null
  
)

export default component.exports